export default function About() {
  const stats = [
    { value: '7+', label: 'Years in Business' },
    { value: '150+', label: 'Clients Served' },
    { value: '500+', label: 'Projects Completed' },
    { value: '100%', label: 'Long Island Local' },
  ];

  return (
    <section id="about" className="py-32 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
          {/* Left: Image */}
          <div className="relative">
            <div className="w-full h-[520px] rounded-2xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/1bf910ea2e950e1df36d3a1d2a91496f.jpg"
                alt="Bellport Branding team — Long Island web design and video production agency"
                title="Bellport Branding — Long Island Digital Agency Team"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Floating badge */}
            <div className="absolute -bottom-6 -right-6 bg-white rounded-2xl shadow-xl p-6 border border-neutral-100">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#1E3A8A]/10">
                  <i className="ri-map-pin-2-fill text-xl text-[#1E3A8A]"></i>
                </div>
                <div>
                  <p className="text-sm font-semibold text-neutral-900">Based in Bellport, NY</p>
                  <p className="text-xs text-neutral-500">Serving all of Long Island</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right: Content */}
          <div>
            <p className="text-sm font-medium text-[#1E3A8A] tracking-wide mb-4">
              ABOUT US
            </p>
            <h2 className="text-4xl md:text-5xl font-semibold text-neutral-900 tracking-tight mb-6 leading-tight">
              Long Island's Local Digital Agency
            </h2>
            <p className="text-base text-neutral-500 leading-relaxed mb-5">
              We're Bellport Branding — a full-service digital agency rooted right here on Long Island. We work exclusively with small businesses across Nassau and Suffolk County who are ready to grow their online presence and attract more local customers.
            </p>
            <p className="text-base text-neutral-500 leading-relaxed mb-10">
              From custom website design and professional videography to short-form video editing and cybersecurity, we handle every piece of your digital strategy so you can focus on running your business. No outsourcing, no cookie-cutter templates — just real work from a real local team that cares about your results.
            </p>

            {/* Stats */}
            <div className="grid grid-cols-2 gap-6 mb-10">
              {stats.map((stat) => (
                <div key={stat.label} className="bg-neutral-50 rounded-xl p-5 border border-neutral-100">
                  <p className="text-3xl font-bold text-[#1E3A8A] mb-1">{stat.value}</p>
                  <p className="text-sm text-neutral-500">{stat.label}</p>
                </div>
              ))}
            </div>

            <div className="flex flex-wrap gap-4">
              <a
                href="#start-project"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById('start-project')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 bg-[#1E3A8A] text-white text-sm font-semibold px-6 py-3 rounded-md hover:bg-[#1E40AF] transition-colors cursor-pointer whitespace-nowrap"
              >
                Start a Project
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href="tel:+16316407888"
                className="inline-flex items-center gap-2 border border-neutral-200 text-neutral-700 text-sm font-semibold px-6 py-3 rounded-md hover:border-[#1E3A8A] hover:text-[#1E3A8A] transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-line"></i>
                (631) 640-7888
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
